import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { FunctionComponent, useMemo, useRef, useState } from "react";
import { TicketApi } from "../../../redux/api/TicketApi";
import { Label, Error } from "@progress/kendo-react-labels";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Popup } from "@progress/kendo-react-popup";
import { Menu } from "@progress/kendo-react-layout";
import { IType } from "../../../types/IType";

const TypeList: FunctionComponent<FieldRenderProps> = props => {
  const {
    label,
    id,
    disabled,
    optional,
    typeId,
    validationMessage,
    onChange,
  } = props;
  const { data: typesList } = TicketApi.useGetMyTypeListQuery(-1)

  const getSelectedPath = (typeId) => {
    let path = '';
    let currentType = typesList?.filter(t => t.ID === typeId)
    if (currentType?.length > 0) {
      let parentType = getSelectedPath(currentType[0].Parent_Id)
      path = (parentType ? parentType + ' > ' : '') + currentType[0].Call_Type
    }
    console.log('getSelectedPath', path)
    return path;
  }
  const selectedPath = useMemo(() => getSelectedPath(typeId), [typeId]);

  //const typeItems = typesList?.filter(l=>{l.Level === 1});
  function fillLevelTypes(type: IType[]) {
    return type?.map((t) => {
      const result: any = {
        id: t.ID,
        text: t.Call_Type,
        items: fillLevelTypes(typesList.filter(tf => tf.Parent_Id === t.ID))
      }
      return result;
    });
  }

  const typeItems = useMemo(() => fillLevelTypes(typesList?.filter(l => l.Parent_Id === null)), [typesList])
  //console.log('Lets go',typeItems);
  const popRef = useRef(null);
  const dropRef = useRef(null);
  const [show, setShow] = useState(false);
  const offSet = useRef({
    left: 0,
    top: 0,
  });
  const onClick = (e) => {
    offSet.current = {
      left: e.nativeEvent.x,
      top: e.nativeEvent.y,
    };
    setShow(!show);

    // setTimeout(() => {
    //   console.log('clicky', popRef?.current, popRef?.current?.element.focus);
    //   popRef.current && popRef.current.element.focus();
    // }, 100);
  };

  window.onclick = (e) => {
    //Check whether the user clicked out of the menu
    console.log('TicketTypeList.tsx window click')
    if (popRef?.current?.element && dropRef?.current?.element && !popRef.current.element.contains(e.target) && !dropRef.current.element.contains(e.target)) {
      setShow(false);
    }
  }

  const itemSelected = (e) => {
    console.log('itemSelected', e, popRef?.current)

    onChange(e.item);

    setShow(false)
  }
  function dropdownBlur(e) {
    //console.log('Debounce the dropdown blur', e);
    //Debounce the dropdown blur otherwise you can't select a top-level itme in the menu
    // setTimeout(() => {
    //   setShow(false);
    // }, 30);
  }
  const isValid = !validationMessage;
  const anchor = useRef();
  const errorId = validationMessage ? `${id}_error` : "";
  return (

    <FieldWrapper >
      <Label
        editorId={id}
        editorValid={isValid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label} {validationMessage && (<Error id={errorId}>{validationMessage}</Error>)}
      </Label>
      <div className={"k-form-field-wrap1 z500"} ref={anchor}>
        <DropDownList ref={dropRef} validationMessage="" valid={isValid} value={selectedPath} opened={false} onOpen={onClick} onBlur={dropdownBlur} />
        <Popup collision={{ vertical: "fit", horizontal: "fit" }} anchor={anchor.current} show={show} offset={offSet.current} style={{ width: 300 }}>
          <Menu ref={popRef} items={typeItems} vertical={true} onSelect={itemSelected} style={{ display: "inline-block" }} className='z500 ticket-context' />
        </Popup>
      </div>
    </FieldWrapper>
  )
}

export default TypeList;